<template>
    <ui-Airboard :panel="'dashboard--notVerified'" :openTab="false" :idView="`componet_${_uid}`" :loading="loading">
        <template v-slot:body>
            <inline-svg class="logo" :src="getImage('mysair-logo.svg')"></inline-svg>
            <hr />
            <div class="mailValidation">{{ message }}</div>
            <hr />
            <router-link v-if="$session.isLoged()" :to="{ name: 'Dashboard' }" class="link mt-2">
                {{ $dicc.verify.back }}
            </router-link>
            <router-link v-else :to="{ name: 'Login' }" class="link mt-2">{{ $dicc.verify.loginAction }}</router-link>
        </template>
    </ui-Airboard>
</template>

<script>
    export default {
        name: 'Verify',
        data: function() {
            return {
                loading: 0,
                message: '',
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                if (this.$route.query.email == null) this.verifyRegister();
                else this.verifyEmail();
            },

            verifyRegister() {
                this.loading++;
                this.$api.verifyRegister(
                    this.$route.query,
                    (data) => {
                        this.$session.login(data.entity);
                        this.$router.push({ name: 'Dashboard' });
                    },
                    (data) => {
                        this.message = data.data.error;
                    },
                    () => this.loading--
                );
            },

            verifyEmail() {
                this.loading++;
                this.$api.verifyEmail(
                    this.$route.query,
                    (data) => {
                        this.$session.login(data.entity);
                        this.$router.push({ name: 'Dashboard' });
                    },
                    (data) => {
                        this.message = data.data.error;
                    },
                    () => this.loading--
                );
            },
        },
    };
</script>
